import * as yup from 'yup';

import { SAFETY_CONCERN } from '../models';

// Typed as string[] on purpose so yup validates the allowed values at runtime
// without narrowing the field's static type to a union (which would clash with
// the empty-string "nothing selected yet" default).
const SAFETY_CONCERN_VALUES: string[] = [SAFETY_CONCERN.YES, SAFETY_CONCERN.NO, SAFETY_CONCERN.UNKNOWN];

// The request form. Dropdown/multiselect fields store arrays (the ControlledField
// contract); single-selects are arrays of length 0 or 1. Scalar text fields and
// the safety-concern radio stay plain strings.
export const changeRequestSchema = yup.object({
  title: yup.string().trim().default(''),
  description: yup.string().trim().default(''),
  reasonOrTrigger: yup.string().trim().default(''),
  desiredOutcome: yup.string().default(''),
  implementationProposal: yup.string().default(''),
  affectedProducts: yup.array(yup.string().required()).default([]),
  affectedQmsAreas: yup.array(yup.string().required()).default([]),
  sourceRecord: yup.array(yup.string().required()).max(1).default([]),
  urgency: yup.array(yup.string().required()).max(1).default([]),
  knownSafetyConcern: yup
    .string()
    .oneOf(['', ...SAFETY_CONCERN_VALUES], 'Select yes, no or unknown.')
    .default(''),
  safetyConcernDescription: yup.string().trim().default(''),
  knownAffectedDocuments: yup.array(yup.string().required()).default([]),
  relatedChanges: yup.array(yup.string().required()).default([]),
  collaborators: yup.array(yup.string().required()).default([]),
  changeManager: yup.array(yup.string().required()).max(1).default([]),
  targetDate: yup.string().default(''),
  changeCategory: yup.array(yup.string().required()).max(1).default([]),
  scopeType: yup.array(yup.string().required()).max(1).default([]),
  criticality: yup.array(yup.string().required()).max(1).default([]),
  assessorFunctions: yup.array(yup.string().required()).default([]),
});

export type TRequestFormData = yup.InferType<typeof changeRequestSchema>;

export const DEFAULT_REQUEST_FORM: TRequestFormData = {
  title: '',
  description: '',
  reasonOrTrigger: '',
  desiredOutcome: '',
  implementationProposal: '',
  affectedProducts: [],
  affectedQmsAreas: [],
  sourceRecord: [],
  urgency: [],
  targetDate: '',
  knownSafetyConcern: '',
  safetyConcernDescription: '',
  knownAffectedDocuments: [],
  relatedChanges: [],
  collaborators: [],
  changeManager: [],
  changeCategory: [],
  scopeType: [],
  criticality: [],
  assessorFunctions: [],
};
